import ProfileService from 'services/ProfileService';

export async function fetchMyUserInfo() {
  const result = await ProfileService.getUserInfo().call();
  return result?.data;
}
